// helpers
import { handleErrorAlert } from "../../../../common/utils/helpers/handleErrorAlert";
import ApiHelper from "../../../../common/utils/apiHelper";
import { buildAirlineMilesAndMoreBookingFields } from "../../../../common/utils/transport/airlineBookingPayload";
import { type TransportAirlineApiContext } from "../../../../common/utils/transport/airlineTransportContext";
import {
  buildDestinationTransportPayload,
  postDestinationTransportEstimation
} from "../../../../common/utils/transport/destinationTransportEstimation";
import { resolveSwissTravelPassApiPaths } from "./helpers/resolveSwissTravelPassApiPaths";
import { mapSwissTravelPassPassengersForApi } from "./helpers/mapSwissTravelPassPassengersForApi";
import { getLeadGuest, getPassengerCategoryByBirthDate } from "../../shared/helpers/leadGuest";
// actions / selectors
import { globalActionCreators, selectApiBaseUrl } from "../../../../common/store/modules/globalModule";
import { confirmationActionCreators } from "../../../../common/store/modules/bookingConfirmationModule";

// Toggle mock for Swiss Travel Pass offers
const USE_MOCK_SWISS_TRAVEL_PASS_OFFERS = false;

const MOCK_SWISS_TRAVEL_PASS_OFFERS_RESPONSE = {
  provider_title: "Swiss Travel Pass",
  provider_description:
    "ZVV 9h Pass / All Zones lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, met consectetur adipisicing elit. Quisquam, met consectetur adipisicing elit. Quisquam, quos lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos lorem is quos lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos lorem i END END END",
  provider_logo: {
    url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/390c0357-516c-45ae-91b6-152fb9996817/65249b87c14fafd.png",
    name: "SWISS_TRAVEL_PASS"
  },
  items: [
    {
      name: "Swiss Travel Pass 3 days",
      offer_code: "ELPSRXB",
      cancellation_policy: "Cancellation policy STP 1",
      has_family_card: false
    },
    {
      name: "Swiss Travel Pass 4 days",
      offer_code: "EGDHHOF",
      cancellation_policy: "Cancellation policy STP 2",
      has_family_card: true
    },
    {
      name: "Cypress Swiss Travel Pass Test Offer",
      offer_code: "EUEKZHX",
      cancellation_policy: "Cancellation policy STP 3",
      has_family_card: false
    },
    {
      name: "Swiss Travel Pass 4 days [copy]",
      offer_code: "ECBMUEY",
      cancellation_policy: "Cancellation policy STP 4",
      has_family_card: false
    },
    {
      name: "STP test External Reference BC",
      offer_code: "EDNTHON",
      cancellation_policy: "Cancellation policy STP 5",
      has_family_card: false
    }
  ]
};

export const swissTravelPassActionTypes = {
  RESET_SWISS_TRAVEL_PASS_STATE: "RESET_SWISS_TRAVEL_PASS_STATE",
  LOAD_TRAVEL_PASS_OFFERS: "LOAD_TRAVEL_PASS_OFFERS",
  SET_TRAVEL_PASS_PREBOOKING_RESPONSE_INFO: "SET_TRAVEL_PASS_PREBOOKING_RESPONSE_INFO",
  LOAD_SWISS_TRAVEL_PASS_COUNTRIES: "LOAD_SWISS_TRAVEL_PASS_COUNTRIES",
  UPDATE_STP_PASSENGERS_LIST: "UPDATE_STP_PASSENGERS_LIST",
  UPDATE_STP_SHOW_VALIDATION_ERRORS: "UPDATE_STP_SHOW_VALIDATION_ERRORS",
  UPDATE_TRAVEL_PASS_PREBOOK_API_ERROR: "UPDATE_TRAVEL_PASS_PREBOOK_API_ERROR",
  TOGGLE_TRAVEL_PASS_BOOKING_ERROR: "TOGGLE_TRAVEL_PASS_BOOKING_ERROR",
  SET_TRAVEL_PASS_BOOKING_RESPONSE_DATA: "SET_TRAVEL_PASS_BOOKING_RESPONSE_DATA",
  TOGGLE_TRAVEL_PASS_PAYMENT_MODAL: "TOGGLE_TRAVEL_PASS_PAYMENT_MODAL"
};

export const initialPassenger = {
  firstName: "",
  lastName: "",
  birthDate: new Date("2001-01-01"),
  hasRemove: false,
  countryOfResidence: null
};

export const initialState = {
  travelPassOffers: null,
  travelPassPrebookingInfoResponse: null,
  travelPassPrebookingError: false,
  travelPassPassengerList: [initialPassenger],
  countries: null,
  showValidationErrors: false,
  swissTravelPassBookingError: false,
  swissTravelPassBookingResponseData: null,
  showSwissTravelPassPaymentModal: false
};

const swissTravelPassModule = (state = initialState, action: any) => {
  switch (action.type) {
    case swissTravelPassActionTypes.RESET_SWISS_TRAVEL_PASS_STATE:
      return {
        ...state,
        ...initialState
      };
    case swissTravelPassActionTypes.LOAD_TRAVEL_PASS_OFFERS:
      return {
        ...state,
        travelPassOffers: action.travelPassOffers
      };
    case swissTravelPassActionTypes.SET_TRAVEL_PASS_PREBOOKING_RESPONSE_INFO:
      return {
        ...state,
        travelPassPrebookingInfoResponse: action.travelPassPrebookingInfoResponse
      };
    case swissTravelPassActionTypes.LOAD_SWISS_TRAVEL_PASS_COUNTRIES:
      return {
        ...state,
        countries: action.countries
      };
    case swissTravelPassActionTypes.UPDATE_STP_PASSENGERS_LIST:
      return {
        ...state,
        travelPassPassengerList: action.travelPassPassengerList
      };
    case swissTravelPassActionTypes.UPDATE_STP_SHOW_VALIDATION_ERRORS:
      return {
        ...state,
        showValidationErrors: action.showValidationErrors
      };
    case swissTravelPassActionTypes.UPDATE_TRAVEL_PASS_PREBOOK_API_ERROR:
      return {
        ...state,
        travelPassPrebookingError: action.travelPassPrebookingError
      };
    case swissTravelPassActionTypes.TOGGLE_TRAVEL_PASS_BOOKING_ERROR:
      return {
        ...state,
        swissTravelPassBookingError: action.swissTravelPassBookingError
      };
    case swissTravelPassActionTypes.SET_TRAVEL_PASS_BOOKING_RESPONSE_DATA:
      return {
        ...state,
        swissTravelPassBookingResponseData: action.swissTravelPassBookingResponseData
      };
    case swissTravelPassActionTypes.TOGGLE_TRAVEL_PASS_PAYMENT_MODAL:
      return {
        ...state,
        showSwissTravelPassPaymentModal: action.showSwissTravelPassPaymentModal
      };

    default:
      return state;
  }
};

export default swissTravelPassModule;

export const swissTravelPassActionCreators = {
  resetsSwissTravelPassStateAction: () => (dispatch: any) => {
    dispatch({
      type: swissTravelPassActionTypes.RESET_SWISS_TRAVEL_PASS_STATE
    });
  },
  getNationalityCountriesAction: () => async (dispatch: any, getState: any) => {
    const apiUrl = selectApiBaseUrl(getState());

    try {
      const res = await ApiHelper.get(`${apiUrl}/countries?exclude=ch`);

      dispatch({
        type: swissTravelPassActionTypes.LOAD_SWISS_TRAVEL_PASS_COUNTRIES,
        countries: res?.data
      });
    } catch (err: any) {}
  },
  getSwissTravelPassOffersAction:
    (transportContext: TransportAirlineApiContext) => async (dispatch: any, getState: any) => {
      const apiUrl = selectApiBaseUrl(getState());
      const paths = resolveSwissTravelPassApiPaths(transportContext);

      // turn on the loader
      dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));
      // load countries while fetching offers
      dispatch(swissTravelPassActionCreators?.getNationalityCountriesAction());

      if (paths.kind === "invalid_airline") {
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
        return;
      }

      try {
        let data: any;

        if (USE_MOCK_SWISS_TRAVEL_PASS_OFFERS) {
          // keep a small delay so loading UX matches real API
          await new Promise(resolve => setTimeout(resolve, 300));
          data = MOCK_SWISS_TRAVEL_PASS_OFFERS_RESPONSE;
        } else {
          const res = await ApiHelper.get(`${apiUrl}/${paths.mainPath}`);
          // Catalog load is synchronous HTTP (guest + airline). WebSocket follows POST estimation only.
          data = res?.data;
        }

        dispatch({
          type: swissTravelPassActionTypes.LOAD_TRAVEL_PASS_OFFERS,
          travelPassOffers: data
        });
      } catch (err: any) {
      } finally {
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
      }
    },
  updateSwissTravelPassengersAction: (travelPassPassengerList: Array<any>) => (dispatch: any) => {
    dispatch({
      type: swissTravelPassActionTypes.UPDATE_STP_PASSENGERS_LIST,
      travelPassPassengerList
    });
  },
  updateShowValidationErrorsAction: (showValidationErrors: boolean) => (dispatch: any) => {
    dispatch({
      type: swissTravelPassActionTypes.UPDATE_STP_SHOW_VALIDATION_ERRORS,
      showValidationErrors
    });
  },
  getPriceTravelPassPrebookAction:
    (params: any, transportContext: TransportAirlineApiContext) => async (dispatch: any, getState: any) => {
      const apiUrl = selectApiBaseUrl(getState()) || "";
      const paths = resolveSwissTravelPassApiPaths(transportContext);
      const travelPassPassengerListState = getState().swissTravelPass.travelPassPassengerList;

      const updatePassengers = mapSwissTravelPassPassengersForApi(travelPassPassengerListState);

      const rawStartDate = typeof params?.start_date === "string" ? params.start_date : "";
      const [datePart, timePart] = rawStartDate.split(" ");

      const basePayload = buildDestinationTransportPayload({
        date: datePart || "",
        time: timePart || "",
        departureAddress: params?.departureAddress ?? params?.origin ?? null,
        departureAddressId: params?.departureAddressId ?? null,
        destinationAddress: params?.destinationAddress ?? params?.destination ?? null,
        destinationAddressId: params?.destinationAddressId ?? null,
        milesAndMore: params?.milesAndMore ?? "",
        offerCode: params?.offer_code
      });

      const apiParams: Record<string, any> = {
        ...basePayload,
        details: {
          passengers: updatePassengers,
          qualityOfService: params?.qualityOfService,
          email: params?.email,
          childrenWithParent: params?.childrenWithParent ?? null
        }
      };

      // turn on the loader
      dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));
      // reset error state
      dispatch({
        type: swissTravelPassActionTypes.UPDATE_TRAVEL_PASS_PREBOOK_API_ERROR,
        travelPassPrebookingError: null
      });

      if (paths.kind === "invalid_airline") {
        dispatch({
          type: swissTravelPassActionTypes.SET_TRAVEL_PASS_PREBOOKING_RESPONSE_INFO,
          travelPassPrebookingInfoResponse: null
        });
        dispatch({
          type: swissTravelPassActionTypes.UPDATE_TRAVEL_PASS_PREBOOK_API_ERROR,
          travelPassPrebookingError: { code: "MISSING_IATA", message: "Missing airport code" }
        });
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
        return;
      }

      try {
        const data = await postDestinationTransportEstimation({
          apiUrl,
          transportContext,
          payload: apiParams,
          v2: { path: "v2/transport/swiss_travel_pass" },
          airline: {
            path: iataCode => `v1/airports/${encodeURIComponent(iataCode)}/transports/SWISS_TRAVEL_PASS`
          }
        });

        dispatch({
          type: swissTravelPassActionTypes.SET_TRAVEL_PASS_PREBOOKING_RESPONSE_INFO,
          travelPassPrebookingInfoResponse: data
        });
        return data;
      } catch (err: any) {
        dispatch({
          type: swissTravelPassActionTypes.SET_TRAVEL_PASS_PREBOOKING_RESPONSE_INFO,
          travelPassPrebookingInfoResponse: null
        });
        dispatch({
          type: swissTravelPassActionTypes.UPDATE_TRAVEL_PASS_PREBOOK_API_ERROR,
          travelPassPrebookingError: err?.response?.data
        });
      } finally {
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
      }
    },
  resetSwissTravelPrebookStateAction: () => (dispatch: any) => {
    dispatch({
      type: swissTravelPassActionTypes.SET_TRAVEL_PASS_PREBOOKING_RESPONSE_INFO,
      travelPassPrebookingInfoResponse: null
    });
  },
  toggleSwissTravelPassBookingErrorAction: (swissTravelPassBookingError: boolean) => (dispatch: any) => {
    dispatch({
      type: swissTravelPassActionTypes.TOGGLE_TRAVEL_PASS_BOOKING_ERROR,
      swissTravelPassBookingError
    });
  },
  buySwissTravelPassTicketAction:
    (params: any, navigate: any, transportContext: TransportAirlineApiContext) =>
    async (dispatch: any, getState: any) => {
      const travelPassPassengerListState = getState().swissTravelPass.travelPassPassengerList;
      const travelPassPrebookingInfoResponseState = getState().swissTravelPass.travelPassPrebookingInfoResponse;
      const paths = resolveSwissTravelPassApiPaths(transportContext);

      // remove bookingResponseDataStorage from the storage, before setting it again
      localStorage.removeItem("bookingResponseDataStorage");

      const apiUrl = selectApiBaseUrl(getState());
      const language = localStorage.getItem("i18nextLng");

      if (paths.kind === "invalid_airline") {
        dispatch(swissTravelPassActionCreators?.toggleSwissTravelPassBookingErrorAction(true));
        return;
      }

      dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));

      // The lead guest is the booking contact; there is no separate guest name field.
      // Age is checked on the travel date (`selectedDate` is a unix timestamp in seconds).
      const travelDate = typeof params?.selectedDate === "number" ? new Date(params.selectedDate * 1000) : null;
      const leadGuest = getLeadGuest(travelPassPassengerListState, (passenger: any) =>
        getPassengerCategoryByBirthDate(passenger?.birthDate, travelDate)
      );

      const apiParams = {
        summary: {
          start_date: params?.selectedDate,
          adult: travelPassPassengerListState?.length,
          timeslot: "00:00",
          offer_code: params?.selectedTravelPassOffer?.offer_code
        },
        personal_information: {
          first_name: leadGuest?.firstName,
          last_name: leadGuest?.lastName,
          email: params?.email,
          phone: "",
          comment: params?.comment ? params?.comment : null
        },
        ...buildAirlineMilesAndMoreBookingFields(transportContext),
        session_id:
          travelPassPrebookingInfoResponseState?.details?.session_id ||
          travelPassPrebookingInfoResponseState?.session_id
      };

      try {
        const response = await ApiHelper.post(`${apiUrl}/${paths.bookingsPath}`, {}, apiParams);

        localStorage.setItem("bookingResponseDataStorage", JSON.stringify(response.data));

        // We can get API status 200, with booking_status=error --> in that case we should show the error page instead of Payment Modal / Confirmation Page
        if (response.data?.booking_status === "error") {
          dispatch(swissTravelPassActionCreators?.toggleSwissTravelPassBookingErrorAction(true));
          return;
        } else {
          dispatch(swissTravelPassActionCreators?.toggleSwissTravelPassBookingErrorAction(false));

          dispatch({
            type: swissTravelPassActionTypes.SET_TRAVEL_PASS_BOOKING_RESPONSE_DATA,
            swissTravelPassBookingResponseData: response.data
          });

          // If price is 0 we will get payment_status=paid from API --> and we should redirect user directly to the /confirmation page (without payment modal)
          if (response.data?.payment_status === "paid") {
            // call booking status action, in order to set new value to the bookingStatus state
            await dispatch(confirmationActionCreators?.getBookingStatusAction());
            // redirect to confirmation
            await navigate(`/${language}/transport/swiss_travel_pass/confirmation`, { replace: true });
          } else {
            // open payment modal (if payment_status is not "paid")
            dispatch(swissTravelPassActionCreators?.toggleSwissTravelPassPaymentModalAction(true));
          }
        }
      } catch (error: any) {
        handleErrorAlert(error);
        dispatch(swissTravelPassActionCreators?.toggleSwissTravelPassBookingErrorAction(true));
      } finally {
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
      }
    },
  toggleSwissTravelPassPaymentModalAction: (showSwissTravelPassPaymentModal: boolean) => (dispatch: any) => {
    dispatch({
      type: swissTravelPassActionTypes.TOGGLE_TRAVEL_PASS_PAYMENT_MODAL,
      showSwissTravelPassPaymentModal
    });
  }
};
